import { useEffect } from 'react';

/**
 * Hook për të përditësuar favicon dhe manifest dinamikisht
 * @param {string} logoUrl - URL e logos që do të përdoret si favicon
 * @param {string} shopName - Emri i dyqanit për manifest
 */
export const useFavicon = (logoUrl, shopName = '') => {
  useEffect(() => {
    // Krijo ose përditëso favicon link
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    
    // Përdor logo si favicon nëse ekziston, përndryshe përdor default
    if (logoUrl && !logoUrl.includes('/logo.png') && !logoUrl.includes('favicon.ico')) {
      link.href = logoUrl;
      link.type = 'image/png'; // Ndrysho type nëse është PNG
    } else {
      link.href = '/favicon.ico';
      link.type = 'image/x-icon';
    }
    
    // Përditëso edhe apple-touch-icon
    let appleLink = document.querySelector("link[rel~='apple-touch-icon']");
    if (!appleLink) {
      appleLink = document.createElement('link');
      appleLink.rel = 'apple-touch-icon';
      document.getElementsByTagName('head')[0].appendChild(appleLink);
    }
    
    if (logoUrl && !logoUrl.includes('/logo.png') && !logoUrl.includes('favicon.ico')) {
      appleLink.href = logoUrl;
    } else {
      appleLink.href = '/logo192.png';
    }

    // Përditëso manifest.json dinamikisht
    let manifestLink = document.querySelector("link[rel~='manifest']");
    if (manifestLink) {
      // Krijo manifest dinamik
      // Lexo manifest.json për të marrë emrin aktual nëse shopName është bosh
      const updateManifest = async () => {
        let finalShopName = shopName;
        if (!finalShopName) {
          try {
            const manifestHref = manifestLink.href;
            // Nëse është blob URL, lexo direkt manifest.json
            if (manifestHref.includes('blob:')) {
              const response = await fetch('/manifest.json');
              const existingManifest = await response.json();
              finalShopName = existingManifest?.short_name || existingManifest?.name?.split(' – ')[0] || '';
            } else {
              const response = await fetch(manifestHref);
              const existingManifest = await response.json();
              finalShopName = existingManifest?.short_name || existingManifest?.name?.split(' – ')[0] || '';
            }
          } catch (e) {
            // Nëse nuk mund të lexohet, përdor string bosh
            console.log('Could not read manifest:', e);
          }
        }
        
        const manifest = {
          short_name: finalShopName ? finalShopName.substring(0, 12) : '',
          name: finalShopName ? `${finalShopName} – Shitje dhe Menaxhim Online` : 'Shitje dhe Menaxhim Online',
          icons: [
            {
              src: logoUrl && !logoUrl.includes('/logo.png') ? logoUrl : '/favicon.ico',
              sizes: '64x64 32x32 24x24 16x16',
              type: logoUrl && !logoUrl.includes('/logo.png') ? 'image/png' : 'image/x-icon'
            },
            {
              src: logoUrl && !logoUrl.includes('/logo.png') ? logoUrl : '/logo192.png',
              type: 'image/png',
              sizes: '192x192'
            },
            {
              src: logoUrl && !logoUrl.includes('/logo.png') ? logoUrl : '/logo512.png',
              type: 'image/png',
              sizes: '512x512'
            }
          ],
          start_url: '.',
          display: 'standalone',
          theme_color: '#000000',
          background_color: '#ffffff'
        };

        // Krijo blob URL për manifest
        const blob = new Blob([JSON.stringify(manifest, null, 2)], { type: 'application/json' });
        const manifestUrl = URL.createObjectURL(blob);
        manifestLink.href = manifestUrl;
      };
      
      updateManifest();
    }
  }, [logoUrl, shopName]);
};

